const AZURE_B2C_CLIENTID = process.env.REACT_APP_AZURE_B2C_CLIENTID;
const AZURE_B2C_TENANTNAME = process.env.REACT_APP_AZURE_B2C_TENANTNAME;
const AZURE_B2C_USERFLOW=  process.env.REACT_APP_AZURE_B2C_USERFLOW;
const ORIGIN = process.env.REACT_APP_WUCA_PUBLIC_URL;

export const b2cPolicies = {
    names: {
      signUpSignIn: AZURE_B2C_USERFLOW ?? '',
    },
    authorities: {
      signUpSignIn: {
        authority:
          'https://' +
          AZURE_B2C_TENANTNAME +
          '.b2clogin.com/' +
          AZURE_B2C_TENANTNAME +
          '.onmicrosoft.com/' + AZURE_B2C_USERFLOW,
      },
    },
    authorityDomain: AZURE_B2C_TENANTNAME + '.b2clogin.com',
  };
  
  /**
   * Configuration object to be passed to MSAL instance on creation.
   * For a full list of MSAL.js configuration parameters, visit:
   * For a full list of MSAL.js configuration parameters, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
   */
  export const msalConfig = {
    auth: {
      clientId: AZURE_B2C_CLIENTID ?? '', // This is the ONLY mandatory field that you need to supply.
      authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
      knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
      redirectUri: ORIGIN ?? window.location.origin, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
      postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
      // Use localStorage to avoid session-only cache loss after idle and cookie edge cases
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: any, message: string) => {
          // Keep logs minimal; useful for diagnosing auth edge cases
          if (level === 3 /* Error */) console.error('MSAL:', message);
        },
        piiLoggingEnabled: false,
        logLevel: 2, // Warn
      },
    },
  };
